var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-parent is-vertical" }, [
    _vm.quotes
      ? _c(
          "article",
          { staticClass: "tile is-child box" },
          [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Batch No")]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          placeholder: "Batch No.",
                          precision: 0,
                        },
                        model: {
                          value: _vm.innerValue.batchNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "batchNo", $$v)
                          },
                          expression: "innerValue.batchNo",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Batch Date")]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("v-date-picker", {
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ inputValue, inputEvents }) {
                                return [
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "div",
                                      { staticClass: "control has-icons-left" },
                                      [
                                        _c(
                                          "input",
                                          _vm._g(
                                            {
                                              staticClass: "input",
                                              attrs: {
                                                type: "text",
                                                placeholder: "Batch Date",
                                                readonly: "",
                                              },
                                              domProps: { value: inputValue },
                                            },
                                            inputEvents
                                          )
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "icon is-small is-left",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-calendar mdi-18px",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3988065790
                        ),
                        model: {
                          value: _vm.batchDate,
                          callback: function ($$v) {
                            _vm.batchDate = $$v
                          },
                          expression: "batchDate",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Min. Batch Size"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          placeholder: "Min. Batch Size",
                          precision: 0,
                        },
                        model: {
                          value: _vm.innerValue.minBatchSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "minBatchSize", $$v)
                          },
                          expression: "innerValue.minBatchSize",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Agreed ARC")]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          symbol: "$",
                          placeholder: "Agreed ARC",
                          precision: 2,
                        },
                        model: {
                          value: _vm.innerValue.agreedArc,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "agreedArc", $$v)
                          },
                          expression: "innerValue.agreedArc",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("ALR Lower Threshold"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          symbol: "$",
                          placeholder: "Agreed ARC",
                          precision: 2,
                        },
                        model: {
                          value: _vm.innerValue.alrLowerThreshold,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "alrLowerThreshold", $$v)
                          },
                          expression: "innerValue.alrLowerThreshold",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("ALR Upper Threshold"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          symbol: "$",
                          placeholder: "Agreed ARC",
                          precision: 2,
                        },
                        model: {
                          value: _vm.innerValue.alrUpperThreshold,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "alrUpperThreshold", $$v)
                          },
                          expression: "innerValue.alrUpperThreshold",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Batch Status"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("div", { staticClass: "select is-fullwidth" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerValue.batchStatus,
                              expression: "innerValue.batchStatus",
                            },
                          ],
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.innerValue,
                                "batchStatus",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(
                          _vm.ormBatchStatusType,
                          function (status, propertyName) {
                            return _c(
                              "option",
                              { key: status, domProps: { value: status } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatOrmBatchStatus(
                                        propertyName
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "is-divider" }),
            _c("orm-batch-statistics", {
              attrs: {
                count: _vm.quotes ? _vm.quotes.length : 0,
                alr: _vm.alr,
                "alr-lower-threshold": _vm.innerValue.alrLowerThreshold,
                "alr-upper-threshold": _vm.innerValue.alrUpperThreshold,
                "average-labour-units": _vm.averageLabourUnits,
                "average-labour-values": _vm.averageLabourValues,
                "average-non-labour-values": _vm.averageNonLabourValues,
                "average-total-ex-gst": _vm.averageTotalExGst,
                "adjusted-total": _vm.adjustedTotal,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "article",
      { staticClass: "tile is-child box" },
      [
        _vm._m(0),
        _c(
          "bulma-table",
          {
            staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
            attrs: {
              columns: _vm.batchQuoteColumns,
              "page-index": _vm.filter.pageIndex,
              "page-size": _vm.filter.pageSize,
              "total-rows": _vm.totalRows,
              "is-loading": _vm.isTableLoading,
              "sort-column": _vm.filter.sortColumn,
              "sort-order": _vm.filter.sortOrder,
              draggable: false,
              "show-pagination": false,
            },
            on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
          },
          [
            _vm._l(_vm.quotes, function (quote, index) {
              return _c(
                "tr",
                {
                  key: quote.quoteId,
                  class: { "is-new-item": quote.isNew },
                  on: {
                    click: function ($event) {
                      return _vm.highlightSelected(index, $event)
                    },
                  },
                },
                [
                  _c("td", [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.viewQuote(quote.quoteId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(quote.quoteNo))]
                    ),
                  ]),
                  _c("td", [_vm._v(_vm._s(quote.claimNo))]),
                  _c("td", [_vm._v(_vm._s(quote.rego))]),
                  _c("td", [_vm._v(_vm._s(quote.customerName))]),
                  _c("td", { staticClass: "has-text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          quote.excess,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                  _c("td", { staticClass: "has-text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatNumberWithRounding(
                          quote.labourHour,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                  _c("td", { staticClass: "has-text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          quote.rate,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                  _c("td", { staticClass: "has-text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          quote.labourTotal,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                  _c("td", { staticClass: "has-text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          quote.partTotal,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                  _c("td", { staticClass: "has-text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          quote.subletTotal,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                  _c("td", { staticClass: "has-text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          quote.miscTotal,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                  _c("td", { staticClass: "has-text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          quote.totalExGst,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                  _c(
                    "td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isInvoiceColumnVisible,
                          expression: "isInvoiceColumnVisible",
                        },
                      ],
                      staticClass: "has-text-centered",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "icon",
                          class: [
                            quote.invoiced
                              ? "has-text-success"
                              : "has-text-danger",
                          ],
                        },
                        [
                          _c("i", {
                            staticClass: "mdi mdi-24px",
                            class: [quote.invoiced ? "mdi-check" : ""],
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.camelCaseToDescription(
                          _vm.getPropertyNameByValue(
                            _vm.ormQuoteStatusTypes,
                            quote.quoteStatusId
                          )
                        )
                      )
                    ),
                  ]),
                  _c("td", [_vm._v(_vm._s(quote.qdeStatus))]),
                  _c(
                    "td",
                    {
                      staticClass: "has-text-right",
                      class: {
                        "has-text-danger": _vm.delta(quote) < 0,
                        "has-text-success": _vm.delta(quote) >= 0,
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.delta(quote),
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass:
                        "has-vertical-middle has-text-centered is-content-width",
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: quote.excess > quote.totalExGst,
                              expression: "quote.excess > quote.totalExGst",
                            },
                          ],
                          staticClass:
                            "icon has-text-danger tooltip is-tooltip-danger is-tooltip-topright",
                          attrs: { "data-tooltip": "Excess exceeds Total" },
                        },
                        [_c("i", { staticClass: "mdi mdi-alert mdi-24px" })]
                      ),
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-danger is-small is-inverted tooltip is-tooltip-topright",
                          attrs: { "data-tooltip": "Remove from batch" },
                          on: {
                            click: function ($event) {
                              return _vm.removeFromBatch(index, quote)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icon is-medium" }, [
                            _c("i", { staticClass: "mdi mdi-minus mdi-24px" }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "content has-text-grey has-text-centered" },
                  [
                    _c("span", { attrs: { icon: "icon is-large" } }, [
                      _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                    ]),
                    _c("p", [_vm._v("Nothing")]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Batched Quotes")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }